import BookingEventTable from '@bookings/components/tables/booking-event-table/booking-event-table.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-profile-bookings',
  components: {
    'bpc-booking-event-table': BookingEventTable,
  },
})
export default class ProfileBookings extends Vue {
  get contactId() {
    return this.$authorizationService.getContactId();
  }

  filterByContactId() {
    return [{ filterField: 'contact_id', modelField: null, value: this.contactId }];
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
